namespace Gamification.Gamification {
    export interface TipologieProdottiForm {
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.StringEditor;
    }

    export class TipologieProdottiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.TipologieProdotti';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TipologieProdottiForm.init)  {
                TipologieProdottiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(TipologieProdottiForm, [
                    'Nome', w0,
                    'Descrizione', w0
                ]);
            }
        }
    }
}
